export default __webpack_public_path__ + "static/media/image-main-3-w@2x.4cf474d2.webp";